import { createWebHistory, createRouter } from "vue-router";
import Home from "./views/Home.vue";
import Performances from "./views/Performances.vue";
import Development from "./views/Development.vue";
import SoundDesign from "./views/SoundDesign.vue";
import Music from "./views/Music.vue";
import ProjectDetail from "./components/ProjectDetail.vue";
import performancesData from '@/assets/data/performances.json';
import developmentData from '@/assets/data/development.json';
import soundDesignData from '@/assets/data/soundDesign.json';
import musicData from '@/assets/data/music.json';

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/performances",
    name: "Performances",
    component: Performances,
  },
  {
    path: "/development",
    name: "Development",
    component: Development,
  },
  {
    path: "/soundDesign",
    name: "SoundDesign",
    component: SoundDesign,
  },
  {
    path: "/music",
    name: "Music",
    component: Music,
  },
  {
    path: "/performances/:slug",
    name: "PerformanceProject",
    component: ProjectDetail,
    props: (route) => ({
      slug: route.params.slug,
      jsonData: performancesData,
      basePath: "/performances",
    }),
  },
  {
    path: "/development/:slug",
    name: "DevelopmentProject",
    component: ProjectDetail,
    props: (route) => ({
      slug: route.params.slug,
      jsonData: developmentData,
      basePath: "/development",
    }),
  },
  {
    path: "/soundDesign/:slug",
    name: "SoundDesignProject",
    component: ProjectDetail,
    props: (route) => ({
      slug: route.params.slug,
      jsonData: soundDesignData,
      basePath: "/soundDesign",
    }),
  },
  {
    path: "/music/:slug",
    name: "MusicProject",
    component: ProjectDetail,
    props: (route) => ({
      slug: route.params.slug,
      jsonData: musicData,
      basePath: "/music",
    }),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;